import { IconContent } from '@icons';

export const gearFilled: IconContent = {
    md: '<path fill-rule="evenodd" d="M13.6 2.98h-3.17l-.68 1.9-1.15.48-1.83-.87-2.25 2.26.87 1.83-.184.443c-.093.222-.177.423-.296.717l-1.9.67v3.17l1.9.68.48 1.15-.87 1.83 2.24 2.24 1.83-.87 1.15.48.68 1.91h3.17l.68-1.91 1.15-.48 1.83.87 2.24-2.24-.87-1.83.48-1.15 1.91-.68v-3.12l-1.91-.67-.48-1.16.87-1.83-2.24-2.24-1.83.87-1.15-.48-.68-1.9.01-.07ZM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z" />',
};
